import { computed } from 'vue'
import { useShoppingStore } from '@/stores/shopping'
import { useSiteConfigStore } from '@/stores/config/site'
import { useUserStore } from '@/stores/user'

export function usePriceKey() {
  const shoppingStore = useShoppingStore()
  const siteConfigStore = useSiteConfigStore()
  const userStore = useUserStore()

  const pricingRules = computed(() => siteConfigStore.getPricingRules || {})
  const isEnabled = computed(() => pricingRules.value.enableDynamicTierPricing === true)
  const totalCart = computed(() => shoppingStore.cartTotalPrice)
  const threshold = computed(() => pricingRules.value.thresholdAmountForTierUpgrade || 0)
  const toPriceKey = computed(() => pricingRules.value.toPriceKey || 'price')
  const excludedUserTypes = computed(() => pricingRules.value.excludedUserTypes || [])
  const excludedProfileKeys = computed(() => pricingRules.value.excludedUserByProfileKey || [])

  const isUserExcluded = computed(() => {
    const currentType = userStore.userType
    const currentProfile = userStore.userInfo || {}

    if (excludedUserTypes.value.includes(currentType)) return true

    return excludedProfileKeys.value.some((key) => currentProfile[key] === true)
  })

  const shouldApplyDynamicPrice = computed(() => {
    return isEnabled.value && !isUserExcluded.value && totalCart.value >= threshold.value
  })

  /**
   * Devuelve la key de precio que debe usarse.
   * @param {Object} product - Producto completo
   * @param {Boolean} isDiscount - Si se quiere el precio con descuento
   * @returns {Number|null}
   */
  const getPriceByKey = (product, isDiscount = false) => {
    const baseKey = shouldApplyDynamicPrice.value ? toPriceKey.value : 'price'
    const key = isDiscount ? `${baseKey}_discount` : baseKey
    return product?.[key] ?? null
  }

  return {
    shouldApplyDynamicPrice,
    getPriceByKey,
    priceKey: computed(() => (shouldApplyDynamicPrice.value ? toPriceKey.value : 'price')),
    priceDiscountKey: computed(() =>
      shouldApplyDynamicPrice.value ? `${toPriceKey.value}_discount` : 'price_discount'
    )
  }
}
